module.exports = __webpack_public_path__ + "static/media/36.72d2e177.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/36.png
// module id = 997
// module chunks = 0